module.exports = __webpack_public_path__ + "static/media/Package-03.10215c40.png";